import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {useTranslation} from 'react-i18next';
import {FormHelperText} from '@mui/material';
import {
    CustomList,
    CustomStyleFormHelperText,
    CustomStyleTextField
} from './Styles';
import {toast} from "react-toastify";
import Cookies from "js-cookie";
import CustomAutoCompleteMenuOption from "./CustomAutoCompleteMenuOption";
import {
    CustomPaperAutocomplete,
    CustomPopperAutocomplete
} from "./CustomComponentsPropsAutoComplete";



/**
 * @param String id: Time picker identifier (required).
 * @param List<Object> data: List of objects that includes id and label (required).
 * @param String value: Input value (required).
 * @param useState setValue: Value update status (required).
 * @param event handleFn: Value update event (required).
 * @param String label: Label title (required).
 * @param String defaultState: default value (optional).
 * @param Boolean required: Variable to indicate if it is required (required).
 * @param Boolean disabled: Variable to disable the input (required).
 * @param Boolean emptyFields: Indicates if the field is an empty field error (required).
 * @param String helperText: Text for the legend, displayed under the input field (optional)
 * @param Boolean blurOnSelect: Control if the input should be blurred when an option is selected:
 - false the input is not blurred.
 - true the input is always blurred.
 - touch the input is blurred after a touch event.
 - mouse the input is blurred after a mouse event.
 * @param Boolean reset: If true, reset input value for input change (optional)
 * @returns {JSX.Element}
 */
export default function AutoCompleteSearch({
                                               id = 'slt_acs_autocomplete',
                                               data,
                                               value,
                                               setValue,
                                               handleFn,
                                               label,
                                               defaultState,
                                               required = true,
                                               disabled = false,
                                               emptyFields = false,
                                               helperText = '',
                                               blurOnSelect = false,
                                               reset = true,
                                               onKeyDownEnter = () => {
                                               },
                                               noOptionsCard = false,
                                               showRenderOption=false,
                                               filterOptions=undefined,
                                               inputValue,
                                               onInputChange,
                                               open,
                                               onClose,
                                               searchIcon,
                                               clearIcon=undefined,
                                               length= 100
                                           }) {
    const {t} = useTranslation();
    const options = Array.isArray(data) ? data : [];
    const lCode = Cookies.get('i18next') || 'en';
    let optionalProps = {}

    if (showRenderOption){
        optionalProps = {
            renderOption: (props, item) => (
            <li style={CustomList} {...props}  key={item.id || item.label}>
            <CustomAutoCompleteMenuOption label={item.label}
                                              subSection={item.subSection}
                                              Icon={item.Icon}
                />
            </li>
        )}
    }

    if (typeof open !== "undefined" && onClose) {
        optionalProps = { ...optionalProps, open: open, onClose:onClose};
    }

    if(typeof searchIcon !== "undefined" ){
        optionalProps = {
            ...optionalProps,
            componentsProps:{
                popupIndicator: {
                    disableRipple: true,
                }
            },
            popupIcon: <span title="" >{searchIcon}</span>
        }
    }

    if(typeof onInputChange !== "undefined"){
        optionalProps = {...optionalProps, onInputChange: onInputChange }
    }

    if(typeof inputValue !== "undefined"){
        optionalProps = {...optionalProps, inputValue: inputValue }
    }

    if(typeof clearIcon !== "undefined"){
        optionalProps = {...optionalProps, clearIcon: clearIcon }
    }

    return (
        <>
            <Autocomplete
                sx={CustomStyleTextField(lCode, searchIcon)}
                required
                size='small'
                disabled={disabled}
                id={id}
                PopperComponent={CustomPopperAutocomplete} // Options container
                PaperComponent={CustomPaperAutocomplete}//Box Container
                options={options}
                value={value}
                blurOnSelect={blurOnSelect}
                className={(emptyFields && !value) ? "input-required" : ""}
                onChange={(event, newValue) => {
                    if (newValue) {
                        setValue(newValue);
                        handleFn(newValue);
                        if (reset) setValue(null);
                    } else {
                        setValue(null);
                    }
                }}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        if (!value) toast.warning(t("select_an_option"));
                        else onKeyDownEnter(event);
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        id={id}
                        label={label ? label : t('search')}
                        required={required}
                        error={emptyFields && (!value || value === '' || value == null)}
                        inputProps={{
                            ...params.inputProps,
                            maxLength: length
                        }}
                    />
                )}
                {...optionalProps}
                noOptionsText={
                    <>
                        {noOptionsCard
                            ?
                                <div className={"p-0 m-0"}>
                                    {noOptionsCard}
                                </div>
                            :
                                t('no_options')
                        }
                    </>
                }
                filterOptions={filterOptions}
            />

            {emptyFields && !value && (
                <FormHelperText error={true} sx={CustomStyleFormHelperText}>
                    {t('requiredField')}
                </FormHelperText>
            )}
            {helperText && !emptyFields && (
                <FormHelperText
                    className={'css-k4qjio-MuiFormHelperText-root'}
                    sx={{...CustomStyleFormHelperText(false)}}
                >
                    {helperText}
                </FormHelperText>
            )}
        </>
    );
}
